import styled, { keyframes } from "styled-components";
import poppinsreg from "../../fonts/Poppins-Regular.otf";
import poppinssemi from "../../fonts/Poppins-SemiBold.otf";
import poppinsbold from "../../fonts/Poppins-Bold.otf";
import portada from "../../fonts/Portada-Bold.ttf";
import soleilbold from "../../fonts/SoleilBold.otf";
import soleillight from "../../fonts/SoleilLight.otf";
import soleilreg from "../../fonts/SoleilRegular.otf";
import soleilbook from "../../fonts/SoleilBook.otf";
import content from "../../includes/content";
import { getAssetURL } from "../../utils";
const dots = getAssetURL("dots.png");
const sidetwo = getAssetURL("side-two.png");
const sidethree = getAssetURL("side-three.png");
const badge = getAssetURL("badge.svg");
const thindots = getAssetURL("thin-dots.svg");
const wing = getAssetURL("wing.svg");
const fadeIn = keyframes`
from {
  opacity: 0;
}

to {
  opacity: 1;
}
`;

const spinny = keyframes`
from {
transform:rotate(0deg);
}
to{
  transform:rotate(720deg);
}`;

const blastoff = keyframes`
0% {
  transform: translate(0,0);
}
20% {
  transform: translate(0,1rem);
}
70%{
  opacity:1;
}
100% {
  opacity:0;
  transform: translate(9rem,1rem);
}
`;

const StyledFSS = styled.article`
--darkblue: #083f88;
--lightblue: #00aae4;
--white: #ffffff;
@font-face {
  font-family: "Soleil";
  font-weight: 300;
  src: url(${soleillight}) format("otf");
  font-display: swap;
}
@font-face {
  font-family: "Soleil";
  font-weight: 400;
  src: url(${soleilreg}) format("opentype");
  font-display: swap;
}
@font-face {
  font-family: "Poppins";
  font-weight: 400;
  src: url(${poppinsreg}) format("opentype");
  font-display: swap;
}
@font-face {
  font-family: "Poppins";
  font-weight: 700;
  src: url(${poppinsbold}) format("opentype");
  font-display: swap;
}
@font-face {
  font-family: "Poppins";
  font-weight: 600;
  src: url(${poppinssemi}) format("opentype");
  font-display: swap;
}
@font-face {
  font-family: "Soleil";
  font-weight: 500;
  src: url(${soleilbook}) format("opentype");
  font-display: swap;
}
@font-face {
  font-family: "Soleil";
  font-weight: 600;
  src: url(${soleilbold}) format("opentype");
  font-display: swap;
}
@font-face {
  font-family: "Portada";
  font-weight: 700;
  src: url(${portada}) format("truetype");
  font-display: swap;
}
.fadeIn{
  animation: ${fadeIn} 0.5s ease-in;
}
.fadeInFast{
  animation: ${fadeIn} 0.2s linear;
  
}
.terms-conditions-disclaimer{
  font-size:8pt;
 }
 margin-top:5rem;
width: 100%;
overflow: hidden;
-ms-overflow-style: 0;
scrollbar-width: 0;
.custom-url-text::-webkit-scrollbar {
  display: none;
}

& * {
  font-family: Soleil, sans-serif !important;
  font-weight: 400;
}
.main{
  position:relative;
  // overflow:hidden;
}
.chain{
  animation:none;
}
.chain.spin{
  animation: ${spinny} 0.5s linear forwards;
}  
.mail.fullsend{
  animation:${blastoff} 0.5s linear forwards;
}
.copy-msg{
  display:none;
  justify-content:center;
  align-items:flex-start;
  border-radius:10px;
  padding:0.15rem;
  padding-top:0.25rem;
  background:var(--darkblue);
  color:white;
position:absolute;
margin-top:3.5rem;
margin-left:0.4rem;
z-index:5;
box-shadow: -1.17709px 1.17709px 5.88544px rgba(0, 0, 0, 0.25);
animation: ${fadeIn} 0.2s ease-in forwards;
}
.copy-msg::before{
  content:'';
  border-left:7px solid transparent;
  border-right:7px solid transparent;
  border-bottom:7px solid var(--darkblue);
  position:absolute;
 margin-top:-0.5rem;
  width: 0px;
  height: 0px;
}
.chain.spin + .copy-msg{
  display:flex;
}

.navbar {
  position: sticky;
  height: 5rem;
  width: 100%;
  margin-top: 0.75rem;
}
.logoImage {
  height: 5rem;
}
.nav-box {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.line {
  display: unset;
  color: var(--darkblue) !important;
}
.line-break {
  display: none;
}
.text-space {
  margin: ${({ pageFour }) => (pageFour ? 0 : "2rem 0 0 0")};
}
.right-col {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
}
.text-space > h3 {
  font-weight: 600;
  margin-bottom: 1rem;
  font-size: 40px;
  color: var(--lightblue);
  white-space: nowrap;
}
.mobileWings {
  display: none;
}
.cert {
  font-family: Portada, serif !important;
  font-style: Bold !important;
  font-weight: 700 !important;
  font-size: 70px;
  color: var(--darkblue);
}
.awarded {
  color: var(--darkblue);
  font-size: 22px;
  font-weight: 400;
  text-align: center;
  margin-top: 2rem;
}
.cert-congrats {
  margin-top: 3rem;
  font-family: Poppins, serif !important;
  font-weight: 400 !important;
  font-size: 40px !important;
  color: var(--darkblue);
}

.cert-name {
  font-style: bold;
  font-weight: 600;
  font-size: 24px !important;
  
}

.text-space > div > p > span {
  font-weight: 600;
  font-size: 25px;
  line-height: 33px;
  text-transform: capitalize;
  color: var(--lightblue);
}
.text-space > div > p {
  font-size: 20px;
  line-height: 35px;
  color: var(--darkblue);
}

button {
  background: var(--darkblue);
  border-radius: 12px;
  font-weight: 400;
  font-size: 22px;
  line-height: 38px;
  text-align: center;
  color: var(--white);
  border: 0;
  padding: 0.6rem 1.25rem;
  margin: 2rem 0 2.5rem 0;
}
.process-button {
  padding: 0.25rem 0.5rem;
}

.regards * {
  margin: 0;
  padding: 0;
}
.regards > :where(p:nth-of-type(1), p:nth-of-type(2)) {
  font-size: 22px;
  line-height: 37px;
  color: #083f88;
}
.regards > p:nth-of-type(3) {
  white-space: nowrap;
}
.doc-text {
  text-align: center;
  font-size: 18px;
}
.regards > p > span {
  font-weight: 600;
  font-size: 30px;
  line-height: 52px;
  color: var(--darkblue);
}
.regards > p:first-of-type {
  font-weight: 400;
  font-size: 22px;
  margin-bottom: 0.5rem;
}
.regards > :where(p:nth-of-type(3), a) {
  font-size: 21.0884px;
  line-height: 32px;
  color: var(--lightblue) !important;
}
.congrats-small-text {
  text-align: center;
}
.regards > a {
  text-decoration: underline;
}
.title-break {
  display: none;
}
.right-col .hide-img {
  display: none;
}

.form-style {
  background: rgb(235, 248, 253);
  border-radius: 150px 0;
  padding: 3rem 1rem;
  width: 26rem;
  text-align: center;
}
.form-title {
  font-weight: 600;
  font-size: 25px;
  line-height: 38px;
  text-align: center;
  color: var(--lightblue);
}
.email-input,
.email-input:focus {
  
  box-sizing: border-box;
  background: var(--white);
  border: 0.5px solid rgb(88, 88, 88, 0.5);
  outline: 0.1px solid rgb(88, 88, 88, 0.5);
  border-radius: 5px;
  padding: 0.25rem 1rem 0.25rem 2.25rem;
}
.email-input::placeholder {
  padding-left: 3rem;
}

.error-text {
  color: red;
  margin-top: 0.5rem;
}
.email-error-box {
  display: flex;
  flex-flow: column nowrap;
  justify-content: flex-start;
  align-items: center;
}
.email-box {
  display: flex;
  flex-flow: column;
  justify-content: flex-start;
  align-items: flex-start;
}
.email-box .image-icon {
  position: absolute;
  width: 2rem;
  height: 1rem;
  margin-top: 0.5rem;
  margin-left: ${(props) => (props.status ? "2rem" : "0.5rem")};
}
.inputs-box div {
  box-sizing: border-box;
  border: 1px solid rgba(0, 170, 228, 0.5);
  border-radius: 7px;
  background: var(--white);
  padding: 0.5rem;
  width: 3rem;
  margin-right: 0.5rem;
  display: flex;
  justify-content: center;
  align-items: center;
}
.ssn-input {
  border: none;
  outline: none;
  border-bottom: 1px solid rgb(88, 88, 88, 0.5);
  width: 2rem;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
}
.inputs-box div:nth-of-type(4) {
  margin: 0;
}
.congrats {
  color: var(--darkblue);
  font-weight: 400;
  font-size: 50px;
  line-height: 75px;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  margin: 3rem 0;
}
.congrats ~ p {
  font-weight: 500;
  font-size: 22px;
  line-height: 28px;
  color: var(--darkblue);
}
.light-button {
  background: var(--lightblue);
  font-size: 18px;
  display: flex;
  cursor: unset;
  justify-content: space-between;
  align-items: center;
  padding: 0.5rem;
  margin: 0.25rem;
}
.share-box {
  display: flex;
  flex-flow: column nowrap;
  justify-content: flex-start;
  align-items: center;
  border: 1.17739px solid var(--lightblue);
  border-radius: 23.5477px;
  padding: 2rem;
  margin-top: 1rem;
  text-align:left;
  background: var(--white);
}

input:focus {
  box-shadow: none;
  outline: none;
}

.custom-url-text {
  overflow: scroll;
  background: var(--darkblue);
  padding: 0.25rem 1rem !important;
  height: auto;
  width: 16rem;
  margin-left: 2rem;
  color: var(--white);
  font-weight: 300;
  border-radius: 5px;
  display: flex;
  flex-flow: row-reverse;
  text-align: left;
  align-items: center;
  border: 2px solid transparent;
  outline: none;
  box-sizing: border-box;
  white-space: nowrap;
}
.custom-url-box {
  display: flex;
  justify-content: center;
  align-items: center;
}
.custom-url-text:focus {
  outline: none;
}
.edit {
  border: 2px solid var(--lightblue);
  box-shadow: -1.17709px 1.17709px 5.88544px rgba(0, 0, 0, 0.25);
  outline: none;
  width: 18rem;
  text-align: center;
  margin-left: 0;
}
.share-icon {
  height: 2.25rem;
  padding: 0.25rem;
  background: var(--white);
  position: relative;
  margin-top: -3rem;
  margin-bottom: 0.5rem;
}
.share-save {
  background: var(--darkblue);
  color: var(--white);
  border-radius: 2.76279px;
  font-weight: 400;
  font-size: 12px;
  margin: 1rem 0.5rem;
  padding: 0.15rem 0;
  min-width: 3.5rem;
  text-align: center;
}
.share-save:nth-of-type(2) {
  background: var(--white);
  color: var(--darkblue);
  border: 1px solid var(--darkblue);
}
.share-title {
  font-weight: 400;
  font-size: 15px;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  color: #083f88;
  font-family: Poppins !important;
}
.share-text {
  font-weight: 400;
  font-size: 15px;
  line-height: 21px;
  color: var(--darkblue);
  cursor: pointer;
  text-decoration: none;
}
.share-text a {
  text-decoration: none;
  color: var(--darkblue);
}
.share-text img {
  margin-right: 0.75rem;
}
.share-text:nth-of-type(1) {
  margin-right: 1.5rem;
}
.certificate {
  position: absolute;
  height: 30rem;
  margin-top: 3rem;
  margin-left: 10rem;
  z-index: 2;
}
.certificate + p {
  position: absolute;
  color: var(--darkblue);
  text-transform: capitalize;
  font-size: 20px;
  font-weight: 600;
  margin-top: -2.5rem;
  margin-left: -2rem;
  z-index: 5;
}
.borrower-name {
  position: absolute;
  margin-top: 47%;
  margin-left: -13%;
}
.loan-amount {
  position: absolute;
  margin-top: 20rem;
  margin-left: -2rem;
}
.offscreen-cert{
position:absolute;
transform:translate(300%,0);
top:0;
}


.text-space .firstButton {
  padding: 0.8rem 1.25rem 0.4rem 1.25rem;
}
background-repeat: no-repeat;
background-position: 50% 0%, 90% 0%, 0% 5%, 40% 105%, 99.5% 98.6%, 60% 97%;
background-size: 5rem, 45rem, 5rem, 5rem, 3rem, 5rem;
${({ pageOne }) =>
  pageOne &&
  `background-image: url(${dots}), url(${content.pageOneImage}),url(${badge}),url(${thindots}),url(${wing}),url(${dots});`}
${({ pageTwo }) =>
  pageTwo &&
  `background-image: url(${dots}), url(${sidetwo}),url(${badge}),url(${thindots}),url(${wing}),url(${dots});`}
${({ pageThree }) =>
  pageThree &&
  `background-image: url(${dots}), url(${sidethree}),url(${badge}),url(${thindots}),url(${wing}),url(${dots});`}
${({ pageFour }) =>
  pageFour &&
  `background-image: url(${dots}),url(${badge}),url(${thindots}),url(${wing}),url(${dots});
  background-position: 50% 0%, 0% 5%,40% 105%,99% 99%,60% 97%;
  background-size: 5rem, 5rem,5rem,3rem,5rem;`}
${({ pageFive }) =>
  pageFive &&
  `background-image: url(${dots}),url(${badge}),url(${thindots}),url(${wing}),url(${dots});
  background-position: 50% 0%, 0% 5%,40% 105%,99% 99%,60% 97%;
  background-size:5rem,5rem,5rem,3rem,5rem;`}

  .pavan {
  color: var(--darkblue) !important;
  font-size: 28px !important;
}
.bottom-margin {
  margin-bottom: 3rem;
}

& .toggle-public {
  all: unset;
  position: relative;
  background: #d4d4d4;
  border-radius: 20px;
  width: 3.25rem;
  height: 1.5rem;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  transition: all 0.4s;
  margin: 0 0.25rem;
  z-index: 1;
  cursor: pointer;
}
& .toggle-public::before {
  content: "";
  position: absolute;
  width: 1.4rem;
  height: 1.4rem;
  background: white;
  border-radius: 50%;
  transition: all 0.4s;
  transform: translateX(5%);
  margin-top: -0.25px;
}
& .toggle-public:checked {
  background: var(--darkblue);
}
& .toggle-public:checked::before {
  transform: translateX(130%);
}

& .header-ref{
  position:absolute;
  width:0;
  height:0;
  top:104vh;
}
& .display-cert-wrapper{
  cursor:pointer;
}

& .tru-guidance{
  margin:0.5rem 3rem 3rem 3rem;
  width:calc(100% - 6rem);
}
// & .tru-guidance :not(.static-image){
//   display:none;
// }
& .static-image{
  display:initial;
}
& .emailHint{
  color:rgb(88,88,88,0.7);
}

& .fss-logo{
position:relative;
height:100%;
max-height:100px;
margin-top:1rem;
}
& .social-icon{
height:2.5rem;
}

table, .table-div{
width:fit-content;
width: -webkit-fit-content;
    width: -moz-fit-content;
margin:1rem;
}

tr td:nth-of-type(1) {
border: 1px solid #dddddd;
text-align: left;
padding: 8px 1.5rem 8px 1rem;
background:var(--lightblue);
color:white;
}
tr td:nth-of-type(2) {
  border: 1px solid #dddddd;
  text-align: left;
  padding: 8px 0.5rem 8px 1rem;

}
& .DL-icon{
  position:relative;
  margin:1rem 0 3rem 0;
}
& .DL-icon img{
  margin:-0.35rem 0 0 0;
  padding:0;
cursor:pointer;
max-height:4.5rem;
}

& .DL-icon p{
  font-size:30px;
font-weight:700;
height:100%;
padding:0;
text-align:left;
margin:0.5rem 0 0 0.5rem;
color:var(--lightblue);
}
& .truapproval-logo{
  position:relative;
  height:200px;
  transform:rotate(3deg);
  margin-top:2rem;
 }
& h3.avoid-text{
  font-size:25px!important;
  margin:0!important;
  font-weight:600;
}
& h3.avoid-text span{
  font-size:25px!important;
  margin:0!important;
  font-weight:600;
  white-space:nowrap;
}
.disclaimer h6{
font-size:14px;
}
.disclaimer p{
font-size:12px;
}
& .share-link{
  display:flex;
  justify-content:center;
  align-items:flex-start;
  position:relative;
  transition:0.4s;

}
& .share-post-box::before{
  content:'';
 border-left:15px solid transparent;
 border-right:15px solid transparent;
 border-bottom:15px solid var(--darkblue);
    position:absolute;
margin-top:-2rem;
width: 0px;
  height: 0px;
}
& .share-post-box{
  display:none;
  position:absolute;
  padding:1rem;
  border:3px solid var(--darkblue);
  background:white;
  z-index:11;
  width:215px;
  height:425px;
  border-radius:20px;
  top:4rem;
  color:black;

}
& .share-link:hover .share-post-box{
  display:flex;
  justify-content:center;
}

& .tap-to-post{
  display:none;
}


input[type="number"] {
  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: textfield;
}

input[type="number"]::-webkit-inner-spin-button,
input[type="number"]::-webkit-outer-spin-button {
    -webkit-appearance: none;
    margin: 0;
}

.guidance-text div{
  font-weight:700;
}

& .guidance-text {
  position:absolute;
  color: #093f83;
  font-size:calc(12px + 0.65vw);
  font-weight:700;
  line-height:100%;
}

@media (min-width: 1850.1px) {
  .tru-guidance :nth-child(2) {
    top: 39% ;
    left: 6% ;
  }  
  .tru-guidance :nth-child(3) {
    top: 21% ;
    right: 22.5% ;
  } 
  .tru-guidance :nth-child(4) {
    top: 33% ;
    right: 8% ;
  }
  .tru-guidance :nth-child(5) {
    top: 47% ;
    right: 6% ;
  }
  .tru-guidance :nth-child(6) {
    top: 62% ;
    right: 5% ;
  }
}

@media (max-width: 1850px) {
  .tru-guidance :nth-child(2) {
    top: 39% ;
    left: 6% ;
  }  
  .tru-guidance :nth-child(3) {
    top: 21% ;
    right: 22.5% ;
  } 
  .tru-guidance :nth-child(4) {
    top: 33% ;
    right: 8% ;
  }
  .tru-guidance :nth-child(5) {
    top: 47% ;
    right: 7% ;
  }
  .tru-guidance :nth-child(6) {
    top: 62% ;
    right: 5% ;
  }
}

@media (max-width: 1425px) {
  background-size: 5rem, 40rem, 5rem, 5rem, 3rem, 5rem;
  background-position: 50% 0%, 100% 0%, 0% 5%, 40% 105%, 95% 95%, 60% 97%;
  ${({ pageFour }) =>
    pageFour &&
    `background-image: url(${dots}),url(${badge}),url(${thindots}),url(${wing}),url(${dots});
  background-position: 50% 0%, 0% 5%,40% 105%,99% 99%,60% 97%;
  background-size: 5rem, 5rem,5rem,3rem,5rem;`};
  ${({ pageFive }) =>
    pageFive &&
    `background-size: 5rem,5rem,5rem,3rem,5rem;
    background-position: 50% 0%, 0% 5%,40% 105%,99% 99%,60% 97%;`};
 

  .certificate {
    margin-left: 5rem;
  }
  .tru-guidance :nth-child(2) {
    top: 39% ;
    left: 6% ;
  }  
  .tru-guidance :nth-child(3) {
    top: 21% ;
    right: 22.5% ;
  } 
  .tru-guidance :nth-child(4) {
    top: 33% ;
    right: 8% ;
  }
  .tru-guidance :nth-child(5) {
    top: 47% ;
    right: 7.5% ;
  }
  .tru-guidance :nth-child(6) {
    top: 62% ;
    right: 5% ;
  }
}
@media (max-width: 1240px) {
  background-size:background-size: 5rem,38rem,5rem,5rem,3rem,5rem;
  background-position: 55% 0%, 100% 20%, 0% 5%,40% 105%, 95% 95%,60% 97%;
  ${({ pageFour }) =>
    pageFour &&
    `background-image: url(${dots}),url(${badge}),url(${thindots}),url(${wing}),url(${dots});
  background-position: 50% 0%, 0% 5%,40% 105%,99% 99%,60% 97%;
  background-size: 5rem, 5rem,5rem,3rem,5rem;`};
  ${({ pageFive }) =>
    pageFive &&
    `background-size: 5rem,5rem,5rem,3rem,5rem;background-position: 50% 0%, 0% 5%,40% 105%,99% 99%,60% 97%;`};
  .text-space > h3 {
    font-size: 32px;
  }
  .text-space > h1 {
    font-size: 55px;
  }
  .tru-guidance :nth-child(2) {
    top: 38.5% ;
    left: 6% ;
  }  
  .tru-guidance :nth-child(3) {
    top: 21% ;
    right: 22.5% ;
  } 
  .tru-guidance :nth-child(4) {
    top: 33% ;
    right: 8% ;
  }
  .tru-guidance :nth-child(5) {
    top: 47% ;
    right: 6% ;
  }
  .tru-guidance :nth-child(6) {
    top: 62% ;
    right: 5% ;
  }
}
@media (max-width: 1060px) {
  background-size: 5rem, 33rem, 5rem,5rem,3rem,5rem;
  background-position: 55% 0%, 100% 30%, 0% 5%,40% 105%, 95% 95%,60% 97%;
  ${({ pageFour }) =>
    pageFour &&
    `background-image: url(${dots}),url(${badge}),url(${thindots}),url(${wing}),url(${dots});
  background-position: 50% 0%, 0% 5%,40% 105%,99% 99%,60% 97%;
  background-size: 5rem, 5rem,5rem,3rem,5rem;`};
  ${({ pageFive }) =>
    pageFive &&
    `background-size: 5rem,5rem,5rem,3rem,5rem; background-position: 50% 0%, 0% 5%,40% 105%,99% 99%,60% 97%;`};
    }


@media (max-width: 991px) {
  .tru-guidance :nth-child(2) {
    top: 37.5% ;
    left: 6% ;
  }  
  .tru-guidance :nth-child(3) {
    top: 20% ;
    right: 22.5% ;
  } 
  .tru-guidance :nth-child(4) {
    top: 32% ;
    right: 8% ;
  }
  .tru-guidance :nth-child(5) {
    top: 46.5% ;
    right: 4% ;
  }
  .tru-guidance :nth-child(6) {
    top: 61% ;
    right: 5% ;
  }
  margin: 5rem 0 2rem 0;
  background: none;

  & .tru-guidance{
    margin:0 0 2rem 0;
    width:calc(100% );
  }
  .regards > p:nth-of-type(3){
    white-space:unset;
  }
  .line{
    display:none;
  }
  .line-break{
    display:unset;
  }
  .mobileWings{
    display:initial;
    height:2.25rem;
    margin-bottom:1rem;
  }
  .form-style {
    background: transparent;
    padding:1rem;
  }
  .cert-congrats {
    font-size: 34px !important;
  }
 
  .text-space * {
    text-align: center;
  }

  .text-space > h3 {
    white-space: initial;
  }
  .text-space > h1 {
    font-size: 70px;
  }
  .text-space > p > span {
    font-size: 35px;
  }
  .centering > p {
    width: 29rem;
  }
  .text-space > .centering {
    width: 100%;
    display: flex;
    justify-content: center;
    margin: 0;
    padding: 0;
  }
  .title-break {
    display: none;
  }
  .right-col .hide-img {
    display: initial;
  }
  .cert-name{
    font-size:22px !important;
  }
  .navbar {
    justify-content: center;
    margin: 1rem 0;
  }
  .logoImage {
    margin: 0;
  }
  .nav-box {
    display: flex;
    justify-content: center;
    align-items: center;
  }
  
& .fss-logo{
  margin-top:0rem;
  }
}
@media (min-width: 2400px) {
  .tru-guidance :nth-child(2) {
    top: 37% ;
  }
  .tru-guidance :nth-child(3) {
    top: 19% ;
  }
  .tru-guidance :nth-child(4) {
    top: 32% ;
  }
  .tru-guidance :nth-child(5) {
    top: 46% ;
    right: 5% ;
  }
  .tru-guidance :nth-child(6) {
    top: 61% ;
  }
}
@media (max-width: 768px) {
  .navbar {
    align-items: flex-start;
    justify-content: center;
  }
  .logoImage {
    margin-left: 1rem;
  }
  .guidance-text {
    font-size:12px;
  }
  & .DL-icon p{
    font-size:21px;
  }
  .tru-guidance :nth-child(2) {
    top: 37.5% ;
    left: 6% ;
  }  
  .tru-guidance :nth-child(3) {
    top: 20% ;
    right: 22.5% ;
  } 
  .tru-guidance :nth-child(4) {
    top: 32% ;
    right: 8% ;
  }
  .tru-guidance :nth-child(5) {
    top: 47% ;
    right: 5% ;
  }
  .tru-guidance :nth-child(6) {
    top: 61% ;
    right: 5% ;
  }
}
@media (max-width: 622px) {
  .text-space > h1 {
    font-size: 60px;
    line-height: 100%;
  }
  .tru-guidance :nth-child(2) {
    top: 37.5% ;
    left: 6% ;
  }  
  .tru-guidance :nth-child(3) {
    top: 20% ;
    right: 22.5% ;
  } 
  .tru-guidance :nth-child(4) {
    top: 32% ;
    right: 8% ;
  }
  .tru-guidance :nth-child(5) {
    top: 47% ;
    right: 5% ;
  }
  .tru-guidance :nth-child(6) {
    top: 61% ;
    right: 5% ;
  }

}

@media (max-width:575px){
  & .fss-logo{
    height:auto;
 width:80%;}
 & .truapproval-logo{
   height:auto;
 width:70%;
  }
  & .tru-guidance :not(.static-image){
    display:initial;
  }
  & .static-image{
    display:none;
  }
  & .guidance-text:first-of-type{
    top:38.5%;
    left:6%;
    
  }
  & .guidance-text:nth-of-type(2){
    top:20%;
    right:22.5%;
  }
  & .guidance-text:nth-of-type(3){
    top:31%;
    right:8%;
  }
  & .guidance-text:nth-of-type(4){
    top:45%;
    right:6%;
    display:flex;
    flex-flow:column nowrap;
    align-items:center;
    font-weight:inherit;
    background-color:rgb(255,255,255);
  }
  & .guidance-text:nth-of-type(4) div{
    padding:0;
    margin:0;
    line-height:105%;
    font-weight:700;
    
  }
  & .guidance-text:last-of-type{
    top:61%;
    right:5.5%;
  }
}



@media (max-width: 500px){
  & .share-link{
    display:flex;
    justify-content:center;
    align-items:flex-start;
    position:relative;
    transition:0.4s;
  
  }
  & .share-post-box::before{
    content:'';
   border-top:15px solid transparent;
   border-left:15px solid transparent;
   border-right:15px solid transparent;
   border-bottom:15px solid var(--darkblue);
      position:absolute;
  margin-top:-3rem;
  width: 0px;
    height: 0px;
  }
  & .share-post-box{
    display:none;
    position:absolute;
    padding:1rem;
    border:3px solid var(--darkblue);
    background:white;
    z-index:11;
    width:215px;
    border-radius:20px;
    top:4rem;
    color:black;
  }
  & .fb.share-post-box{
    margin-left:14rem;
  }
  & .insta.share-post-box{
    margin-left:5rem;
    
  }
  & .lnk.share-post-box{
    margin-left:-5rem;
    
  }
  & .X.share-post-box{
    margin-left:-16rem;

  }
  & .share-link:hover .share-post-box{
    display:flex;
    justify-content:center;
  }
  & .tap-to-post{
    display:block;
    position:absolute;
    top:0;
    font-size:8pt;
  }
  & .DL-icon p{
    font-size:18px;

  }
}


@media (max-width: 450px) {
  & h3.avoid-text, & h3.avoid-text span{
    font-size:18px!important;
  
  }
  .firstButton{
    font-size:20px;
  }
  .text-space > h3 {
    font-size: 25px;
  }
  .text-space > h1 {
    font-size: 35px;
  }

}

@media (max-width: 400px) {
  
  & .fss-logo {
    width:100%;
      }
  & .truapproval-logo{
    width:100%;
    height:auto;
    postition:absolute;
    margin:0;
  }
  & .truapproval-logo-box{
    overflow:hidden;
    width:100%;
  }

  .light-button{
    font-size:16px;
    line-height:unset;
  }
  .cert-name{
    font-size:20px!important;
  }
  .awarded {
    font-size: 18px;
  }
  .form-title {
    font-size: 20px;
  }
  .firstButton{
    font-size:16px;
  }
  .text-space > h3 {
    font-size: 20px;
  }
  .tru-guidance :nth-child(2){
    top:37.5%;
  }
  .text-space > h1 {
    font-size: 33px;
  }
  & .share-box {
    padding: 0.5rem;
  }
  & .social-icon{
    height:2rem;
    }
  & .guidance-text {
      font-size:10px;
    }
}

@media (max-width: 360px) {
  overflow: hidden;
  .firstButton{
    font-size:14px;
  }
  .logoImage {
    height: unset;
    margin-left: 0;
    width: 100%;
  }
  .DL-icon{
    margin: 1rem 1rem 2rem 1.9rem;
  }
  & .DL-icon p{
    font-size:15px;
  }
}
`;

export default StyledFSS;
